import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';

// Should do a better refactor to pass user's data to the pages once, this will be in a dedicated US

export const load = (async (event) => {
	event.depends('loadUser:init');
	await event.parent();

	return {
		pagename: routesPagename.PROFILE_FAVORITES,
	};
}) satisfies PageLoad;
